import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad1ac8c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "upload_file"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "添加附件", -1))
const _hoisted_3 = { style: {"border":"1px solid #ccc"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Editor = _resolveComponent("Editor", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isExtra)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_upload, {
            name: "file",
            headers: _ctx.uploadHeaders,
            action: _ctx.uploadAction,
            data: _ctx.uploadFormData,
            onChange: _ctx.handleChange,
            "file-list": _ctx.fileList
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["headers", "action", "data", "onChange", "file-list"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Toolbar, {
        style: {"border-bottom":"1px solid #ccc"},
        editor: _ctx.editorRef,
        defaultConfig: _ctx.toolbarConfig,
        mode: _ctx.mode
      }, null, 8, ["editor", "defaultConfig", "mode"]),
      _createVNode(_component_Editor, {
        style: {"height":"500px","overflow-y":"hidden"},
        modelValue: _ctx.valueHtml,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueHtml) = $event)),
        defaultConfig: _ctx.editorConfig,
        mode: _ctx.mode,
        onOnCreated: _ctx.handleCreated
      }, null, 8, ["modelValue", "defaultConfig", "mode", "onOnCreated"])
    ])
  ]))
}